import {createFileRoute, Link} from '@tanstack/react-router'
import DailyMenu from "@components/dailyMenu.tsx";
import {Alert, Anchor, Container, LoadingOverlay, Stack, Tabs, Title} from "@mantine/core";
import {IconAlertHexagon, IconInfoCircle} from "@tabler/icons-react";
import {format, isAfter, parse} from "date-fns";
import {cs} from "date-fns/locale";
import {useTodayDailyMenu} from "@state/server/dailyMenu.query.ts";

export const Route = createFileRoute('/_authenticated/_dailymenu/dailymenu/')({
	component: RouteComponent,
})

function RouteComponent() {
	const formatedDate = format(new Date(), "EEEE, do MMMM yyyy", {locale: cs})
	const {data, isLoading, isError, error} = useTodayDailyMenu()

	const pastOrderWindow = isAfter(new Date(), parse(data?.orderBy ?? "", "HH:mm:ss", new Date()));

	return (
		<Tabs.Panel value={"today"}>
			<Container fluid>
				<LoadingOverlay visible={isLoading} zIndex={1000} overlayProps={{radius: "sm", blur: 2}}/>
				<Title order={2} py={"md"}>Dnes je {formatedDate}</Title>

				<Stack style={{padding: "1em 0"}}>
					{/*@ts-expect-error raaah*/}
					{(isError && error.status! == 404) &&
                        <Alert variant={"light"} title={"Chyba"} color={"zmrzlina-red.9"} icon={<IconAlertHexagon/>}>
                            Pro dnešek není vytvořená nabídka a v aplikaci se ukazuje, že je zavřeno. Pokud ji chcete
                            vytvořit,
                            můžete <Anchor c={"zmrzlina-red.9"} component={Link} to={"/dailymenu/new"}>kliknutím sem</Anchor>.
                        </Alert>}

					{/*<Alert variant={"light"} color={"zmrzlina-yellow"} icon={<IconAlertTriangle/>} title={"Upozornění"}
					   withCloseButton>
					Není vytvořená denní nabídka na zítřek. Uživatelům se ráno ukáže, že je zavřeno. Založíte ji <Anchor
					c={"zmrzlina-yellow"}>kliknutím sem</Anchor>.
				</Alert>*/}

					{(data && pastOrderWindow) &&
                        <Alert variant={"light"} color={"blue"} icon={<IconInfoCircle/>} title={"Info"}>
                            Nyní již nelze objednávat.
                        </Alert>}
				</Stack>
				{data && <DailyMenu dailyMenu={data}/>}
			</Container>
		</Tabs.Panel>)
}
